(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/weekpicker.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/weekpicker.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.WeekPicker = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.tipset.templates.weekpicker(data);
    },
    ui: {
      weekInputs: '.btn-group-weekpicker'
    },
    events: {
      'click @ui.weekInputs': 'onWeekChange'
    },

    modelEvents: {
      change: 'render'
    },

    onWeekChange: function(e) {
      var numWeeks = isNaN(e.target.value) ? 1 : parseInt(e.target.value, 10);
      this.model.setNumDraws(numWeeks);
    }
  });
})(Backbone, _, svs);

 })(window);